export { AnalystCoveragePage as default } from '@/components/pages/Ir/Stock/AnalystCoverage'
